export default __webpack_public_path__ + "static/6-sustainability-mobile-66c058ef611b27d874b18e5f7ab56a50.jpg";